import { CreateSurgicalOrderGuideConsultAuthorization } from 'domain/usecases/surgical-order-guides/create-surgical-order-guide-consult-authorization'
import { SurgicalOrderGuidesRepository } from 'repository/repositories/surgical-order-guides/surgical-order-guides-repository'

export class RemoteCreateSurgicalOrderGuideConsultAuthorization
  implements CreateSurgicalOrderGuideConsultAuthorization
{
  constructor(
    private readonly surgicalOrderGuidesRepository: SurgicalOrderGuidesRepository
  ) {}
  async create(
    params: CreateSurgicalOrderGuideConsultAuthorization.Params
  ): Promise<CreateSurgicalOrderGuideConsultAuthorization.Model> {
    return await this.surgicalOrderGuidesRepository.createSurgicalOrderGuideConsultAuthorization(
      params
    )
  }
}
